(() => {
  if (window.nativeProductToolsReady) return;
  window.nativeProductToolsReady = true;
  const dialog = document.querySelector('[data-native-quick-view-dialog]');
  let activeRequest;
  let opener;
  let frame;
  let restoreAfterBrowse = false;
  let handingOffToCart = false;

  function syncFavoriteState(button) {
    const alpine = window.RivoProfileAlpine;
    if (!alpine?.store || button.dataset.rivoFavoriteLoaded !== 'true') return;
    const favorites = alpine.store('rivo_favorite_products');
    const saved = Array.isArray(favorites) && favorites.some(item => String(item.remote_id) === button.dataset.productId && item.active !== false);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.addLabel);
    button.classList.toggle('rivo-favorite-active', saved);
    button.hidden = false;
  }

  function initializeFavorites() {
    const buttons = [...document.querySelectorAll('[data-native-favorite]')];
    if (!buttons.length) return;
    const alpine = window.RivoProfileAlpine;
    const widget = document.getElementById('rivo-account-slideout');
    const enabled = alpine?.store?.('rivo_aw_settings')?.favorites_enabled === true;
    const component = enabled && widget && alpine.$data?.(widget);
    if (!enabled || typeof component?.initializeFavoriteButtons !== 'function') {
      buttons.forEach(button => { button.hidden = true; });
      return;
    }
    const pending = buttons.some(button => button.dataset.rivoFavoriteLoaded !== 'true');
    if (pending) component.initializeFavoriteButtons();
    buttons.forEach(syncFavoriteState);
  }

  function scheduleFavorites() {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; initializeFavorites(); });
  }

  async function openQuickView(trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    const productUrl = new URL(trigger.href, window.location.origin);
    if (productUrl.origin !== window.location.origin) return false;
    const card = trigger.closest('[data-native-product-card]');
    const variant = card?.querySelector('[data-native-variant]')?.value;
    if (variant) productUrl.searchParams.set('variant', variant);
    const requestUrl = new URL(productUrl);
    requestUrl.searchParams.set('section_id', 'native-quick-view');
    activeRequest?.abort();
    const request = new AbortController();
    activeRequest = request;
    opener = trigger;
    const content = dialog.querySelector('[data-native-quick-view-content]');
    const details = dialog.querySelector('[data-native-quick-view-details]');
    details.href = productUrl.href;
    const loading = document.createElement('p');
    loading.dataset.nativeQuickViewLoading = '';
    loading.setAttribute('role', 'status');
    loading.textContent = dialog.dataset.loadingLabel;
    content.replaceChildren(loading);
    dialog.setAttribute('aria-label', trigger.getAttribute('aria-label') || trigger.textContent);
    dialog.removeAttribute('aria-labelledby');
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-native-quick-view-close]').focus();
    let timedOut = false;
    const timeout = setTimeout(() => { timedOut = true; request.abort(); }, 15000);
    try {
      const response = await fetch(requestUrl, { credentials:'same-origin', signal:request.signal });
      if (!response.ok) throw new Error('unavailable');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = documentFragment.querySelector('[data-native-quick-view-product]');
      if (!product?.querySelector('[data-native-product-card]')) throw new Error('unavailable');
      if (request !== activeRequest || !dialog.open) return true;
      content.replaceChildren(product);
      const heading = product.querySelector('.native-product-card__title');
      if (heading?.id) dialog.setAttribute('aria-labelledby', heading.id);
      document.dispatchEvent(new CustomEvent('native:quick-view:loaded', { detail:{root:product} }));
    } catch (error) {
      if ((error.name !== 'AbortError' || timedOut) && request === activeRequest && dialog.open) {
        const status = document.createElement('p');
        status.setAttribute('role', 'alert');
        status.textContent = dialog.dataset.errorLabel;
        content.replaceChildren(status);
      }
    } finally {
      clearTimeout(timeout);
    }
    return true;
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-native-variant]') || !dialog?.contains(event.target)) return;
    const details = dialog.querySelector('[data-native-quick-view-details]');
    const url = new URL(details.href);
    url.searchParams.set('variant', event.target.value);
    details.href = url.href;
  });
  document.addEventListener('product:added', event => {
    if (!dialog?.open || !dialog.contains(event.target)) return;
    // Release modal/inert state before the existing cart listeners handle success.
    handingOffToCart = true;
    dialog.close();
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-native-quick-view]');
    if (trigger && dialog && typeof dialog.showModal === 'function' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      openQuickView(trigger);
    }
    if (event.target.closest('[data-native-quick-view-close]')) dialog?.close();
  });
  dialog?.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || event.target.closest('dialog') !== dialog) return;
    const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')]
      .filter(node => node.getClientRects().length && !node.closest('[hidden]') && node.closest('dialog') === dialog);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  dialog?.addEventListener('close', () => {
    const returnFocus = !handingOffToCart;
    handingOffToCart = false;
    activeRequest?.abort();
    activeRequest = null;
    dialog.querySelector('[data-native-quick-view-content]').replaceChildren();
    if (!returnFocus) return;
    if (opener?.isConnected) opener.focus();
    else {
      const fallback = document.querySelector('[data-native-filter-toolbar], main h1');
      if (fallback?.getClientRects().length) { fallback.setAttribute('tabindex','-1'); fallback.focus({preventScroll:true}); }
    }
  });
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });

  document.addEventListener('native:browse:before-update', event => {
    if (dialog?.open && opener && event.detail.root.contains(opener)) { restoreAfterBrowse = true; dialog.close(); }
  });
  document.addEventListener('native:browse:updated', event => {
    if (!restoreAfterBrowse) return;
    restoreAfterBrowse = false;
    const fallback = event.detail.root.querySelector('[data-native-filter-toolbar], h1');
    if (fallback?.getClientRects().length) { fallback.setAttribute('tabindex','-1'); fallback.focus({preventScroll:true}); }
  });
  ['rivo-accounts:loaded', 'rivo-accounts:initialized', 'rivo-accounts:items:updated', 'rivo-accounts:shopify:login', 'native:browse:updated', 'recentlyviewed:visible'].forEach(name => document.addEventListener(name, scheduleFavorites));
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-native-favorite]') || node.querySelector('[data-native-favorite]'))))) scheduleFavorites();
  }).observe(document.documentElement, {childList:true, subtree:true});
  scheduleFavorites();
})();
